// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
  $WithRegattas,
} from 'common.data';

// Global Enums
import {
  AdminStatus,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputCheckbox,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  adminStatusLabel,
} from 'common.language';

// Types
type $Props = $Translate & {
  item: $ModelUpsertParams<'Admin'> | $WithRegattas<$Model<'Admin'>>;
};

const AdminFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Name')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
        <Col>
          <AvField
            label={t('Email')}
            name={'Email'}
            required
            type={'email'}
            value={item.Email}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Phone')}
            name={'Phone'}
            value={item.Phone}
          />
        </Col>
        <Col>
          <AvField
            label={t('Password')}
            name={'Password'}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col>
              <div className={'align-checkbox'}>
                <InputCheckbox
                  label={t('Superuser')}
                  name={'Super'}
                  value={item.Super}
                />
              </div>
            </Col>
            <Col>
              <div className={'align-checkbox'}>
                <InputCheckbox
                  label={t('Review')}
                  name={'Review'}
                  value={item.Review}
                />
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <AvField
            label={t('Status')}
            name={'Status'}
            required
            type={'select'}
            value={item.Status}
          >
            {_.map(
              AdminStatus,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(adminStatusLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
    </>
  );
};

export default AdminFieldsView;
